import React, { useState, useEffect } from 'react'
import {
  Panel,
  Row,
  Col,
  ControlLabel,
  Input,
  Form,
  SelectPicker,
  DatePicker,
  RadioGroup,
  Radio,
  CheckPicker,
} from 'rsuite'
import { isRequired, isValidators, requiredFiled } from '../../../utils/ValidatorUtils'
import ErrorMessage from '../../../components/message/errorMessage/ErrorMessage'
import classNames from 'classnames'
import moment from 'moment'
import { DATE_PICKER_FORMAT, LOCAL_DAY_TH } from '../../../constants/date'

export default function OverduePaymentPeriodForm({
  schema: _schema,
  register,
  errors,
  error,
  Controller,
  control,
  setValue,
  clearErrors,
  getValues,
  handelPreview,
  clearValue,
  ...props
}) {
  const [schema, setSchema] = useState(_schema)
  const [startDate, setStartDate] = useState(null)
  const [endDate, setEndDate] = useState(null)
  const [fromBudgetYearOptions, setFromBudgetYearOptions] = useState(
    schema.budgetYearStartOption.options
  )
  const [toBudgetYearOptions, setToBudgetYearOptions] = useState(schema.budgetYearEndOption.options)

  useEffect(() => {
    if (!clearValue) {
      setStartDate(null)
      setEndDate(null)

      const indexOptionFromBudgetYear = schema.budgetYearEndOption.options.length - 1
      const indexOptionToBudgetYear = schema.budgetYearEndOption.options.length - 1

      setValue(
        schema.budgetYearStartOption.name,
        schema.budgetYearStartOption.options[indexOptionFromBudgetYear].value
      )
      setValue(
        schema.budgetYearEndOption.name,
        schema.budgetYearEndOption.options[indexOptionToBudgetYear].value
      )
    }
  }, [clearValue])

  const handleChangeBudgetYear = (name, value) => {
    console.log(name, value)
    if (value) {
      let bgy = getValues(name)
      if (!bgy) {
        setValue(name, value)
        clearErrors(name)
      } else if (name == schema.budgetYearStartOption.name && bgy > value) {
        setValue(name, value)
      } else if (name == schema.budgetYearEndOption.name && bgy < value) {
        setValue(name, value)
      }

      if (name == schema.budgetYearStartOption.name) {
        setFromBudgetYearOptions(
          schema.budgetYearStartOption.options.filter((e) => e.value <= value)
        )
      }

      if (name == schema.budgetYearEndOption.name) {
        setToBudgetYearOptions(schema.budgetYearEndOption.options.filter((e) => e.value >= value))
      }
    } else {
      if (name == schema.budgetYearStartOption.name) {
        setFromBudgetYearOptions(schema.budgetYearStartOption.options)
      }

      if (name == schema.budgetYearEndOption.name) {
        setToBudgetYearOptions(schema.budgetYearEndOption.options)
      }
    }
  }

  return (
    <>
      <Form id="mainContainer">
        <Row>
          <Col
            lg={4}
            md={4}
            sm={8}
            xs={8}
            style={{
              marginTop: '5px',
              padding: '8px',
              textAlign: 'right',
            }}
          >
            <ControlLabel>
              {requiredFiled(schema.projectStartDate.validators, schema.projectStartDate.label)}
            </ControlLabel>
          </Col>
          <Col lg={8} md={8} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
            <ErrorMessage error={errors[schema.projectStartDate.name]} />
            <Controller
              name={schema.projectStartDate.name}
              control={control}
              defaultValue={schema.projectStartDate.value ? schema.projectStartDate.value : null}
              rules={isValidators(schema.projectStartDate.validators)}
              render={(props) => {
                return (
                  <DatePicker
                    format="DD/MM/YYYY"
                    locale={LOCAL_DAY_TH}
                    block
                    value={props.value}
                    onChange={(date) => {
                      props.onChange(date)
                    }}
                  />
                )
              }}
            />
          </Col>
          <Col
            lg={4}
            md={4}
            sm={8}
            xs={8}
            style={{
              marginTop: '5px',
              padding: '8px',
              textAlign: 'right',
            }}
          >
            <ControlLabel>
              {requiredFiled(schema.projectEndDate.validators, schema.projectEndDate.label)}
            </ControlLabel>
          </Col>
          <Col lg={8} md={8} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
            <ErrorMessage error={errors[schema.projectEndDate.name]} />
            <Controller
              name={schema.projectEndDate.name}
              control={control}
              defaultValue={schema.projectEndDate.value ? schema.projectEndDate.value : null}
              rules={isValidators(schema.projectEndDate.validators)}
              render={(props) => {
                return (
                  <DatePicker
                    format="DD/MM/YYYY"
                    locale={LOCAL_DAY_TH}
                    block
                    value={props.value}
                    onChange={(date) => {
                      props.onChange(date)
                    }}
                  />
                )
              }}
            />
          </Col>
        </Row>
        <Row>
          {schema?.budgetYearStartOption && (
            <>
              <Col
                lg={4}
                md={4}
                sm={8}
                xs={8}
                style={{
                  marginTop: '5px',
                  padding: '8px',
                  textAlign: 'right',
                }}
              >
                {requiredFiled(
                  schema.budgetYearStartOption.validators,
                  schema.budgetYearStartOption.label
                )}
              </Col>
              <Col lg={8} md={8} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
                <ErrorMessage error={errors[schema.budgetYearStartOption.name]} />
                <Controller
                  name={schema.budgetYearStartOption.name}
                  control={control}
                  defaultValue={
                    fromBudgetYearOptions
                      ? Math.max(...fromBudgetYearOptions.map((item) => item.value))
                      : schema.budgetYearStartOption.value
                  }
                  // rules={isValidators(schema.fromBudgetYear.validators)}
                  render={(props) => {
                    return (
                      <SelectPicker
                        data={fromBudgetYearOptions}
                        // disabled={disabledValue.fromBudgetYear}
                        value={props.value}
                        block
                        placeholder={`เลือก${schema.budgetYearStartOption.label}`}
                        onChange={(value) => {
                          props.onChange(value)
                          handleChangeBudgetYear(schema.budgetYearEndOption.name, value)
                        }}
                      />
                    )
                  }}
                />
              </Col>
            </>
          )}

          {schema?.budgetYearEndOption && (
            <>
              <Col
                lg={4}
                md={4}
                sm={8}
                xs={8}
                style={{
                  marginTop: '5px',
                  padding: '8px',
                  textAlign: 'right',
                }}
              >
                {requiredFiled(
                  schema.budgetYearEndOption.validators,
                  schema.budgetYearEndOption.label
                )}
              </Col>
              <Col lg={8} md={8} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
                <ErrorMessage error={errors[schema.budgetYearEndOption.name]} />
                <Controller
                  name={schema.budgetYearEndOption.name}
                  control={control}
                  defaultValue={
                    toBudgetYearOptions
                      ? Math.max(...toBudgetYearOptions.map((item) => item.value))
                      : schema.budgetYearEndOption.value
                  }
                  // rules={isValidators(schema.budgetYearEndOption.validators)}
                  render={(props) => {
                    return (
                      <SelectPicker
                        data={toBudgetYearOptions}
                        // disabled={disabledValue.toBudgetYear}
                        value={props.value}
                        block
                        placeholder={`เลือก${schema.budgetYearEndOption.label}`}
                        onChange={(value) => {
                          props.onChange(value)
                          handleChangeBudgetYear(schema.budgetYearStartOption.name, value)
                        }}
                      />
                    )
                  }}
                />
              </Col>
            </>
          )}
        </Row>
        <Row>
          <Col
            lg={4}
            md={4}
            sm={8}
            xs={8}
            style={{
              marginTop: '5px',
              padding: '8px',
              textAlign: 'right',
            }}
          >
            {schema.projectStatusOption.label}
          </Col>
          <Col lg={8} md={8} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
            <ErrorMessage error={errors[schema.projectStatusOption.name]} />
            <Controller
              name={schema.projectStatusOption.name}
              control={control}
              defaultValue={schema.projectStatusOption.value}
              // rules={isValidators(schema.projectDepartment.validators)}
              render={(props) => {
                return (
                  <CheckPicker
                    data={schema.projectStatusOption.options}
                    // disabled={disabledValue.constYear}
                    value={props.value}
                    block
                    placeholder={`เลือก${schema.projectStatusOption.label}`}
                    onChange={(value) => {
                      props.onChange(value)
                      // onChangeMainProject(value)
                    }}
                  />
                )
              }}
            />
          </Col>
          <Col
            lg={4}
            md={4}
            sm={8}
            xs={8}
            style={{
              marginTop: '5px',
              padding: '8px',
              textAlign: 'right',
            }}
          >
            {schema.billPaymentStatus.label}
          </Col>
          <Col lg={8} md={8} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
            <ErrorMessage error={errors[schema.billPaymentStatus.name]} />
            <Controller
              name={schema.billPaymentStatus.name}
              control={control}
              defaultValue={schema.billPaymentStatus.value}
              // rules={isValidators(schema.projectDepartment.validators)}
              render={(props) => {
                return (
                  <CheckPicker
                    sticky
                    data={schema.billPaymentStatus.options}
                    // disabled={disabledValue.constYear}
                    value={props.value}
                    block
                    placeholder={`เลือก${schema.billPaymentStatus.label}`}
                    onChange={(value) => {
                      props.onChange(value)
                      // onChangeMainProject(value)
                    }}
                  />
                )
              }}
            />
          </Col>
        </Row>

        {schema.projectDepartment && (
          <Row>
            <Col
              lg={4}
              md={4}
              sm={8}
              xs={8}
              style={{
                marginTop: '5px',
                padding: '8px',
                textAlign: 'right',
              }}
            >
              {schema.projectDepartment.label}
            </Col>
            <Col lg={8} md={8} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
              <ErrorMessage error={errors[schema.projectDepartment.name]} />
              <Controller
                name={schema.projectDepartment.name}
                control={control}
                defaultValue={schema.projectDepartment.value}
                // rules={isValidators(schema.projectDepartment.validators)}
                render={(props) => {
                  return (
                    <SelectPicker
                      data={schema.projectDepartment.options}
                      // disabled={disabledValue.toBudgetYear}
                      value={props.value}
                      block
                      placeholder={`เลือก${schema.projectDepartment.label}`}
                      onChange={(value) => {
                        props.onChange(value)
                      }}
                    />
                  )
                }}
                // render={(props) => {
                //   return (
                //     <CheckPicker
                //       data={schema.projectDepartment.options}
                //       // disabled={disabledValue.constYear}
                //       value={props.value}
                //       block
                //       placeholder={`เลือก${schema.projectDepartment.label}`}
                //       onChange={(value) => {
                //         props.onChange(value)
                //         // onChangeMainProject(value)
                //       }}
                //     />
                //   )
                // }}
              />
            </Col>
          </Row>
        )}
      </Form>
    </>
  )
}
